import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core'
import { provideRouter } from '@angular/router'
import { routes } from './app.routes'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { AuthInterceptor } from './core/interceptors/auth.interceptor'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core'
import { CustomDateAdapter } from './shared/directives/customDateAdapter'
import { CurrencyPipe } from '@angular/common'
import { provideEnvironmentNgxMask } from 'ngx-mask'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { PtBrPaginatorIntl } from './shared/utils/pt-br-paginator-intl'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    importProvidersFrom(HttpClientModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true, //
    },
    importProvidersFrom(MatNativeDateModule),
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MatPaginatorIntl, useClass: PtBrPaginatorIntl },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MM/YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MM/YYYY',
        },
      },
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    CurrencyPipe,
    provideEnvironmentNgxMask(),
  ],
}
